import CreditCardIcon from '@mui/icons-material/CreditCard'
import { Box, Button, Stack, Typography } from '@mui/material'
import capitalize from 'lodash/capitalize'
import { UserBillingProfile } from 'types'
import { formatCardExpiry } from '../utils'

export function PaymentMethodSection({
  billingProfile,
  onAddCard,
  onRemoveCard,
  disabled = false,
}: {
  billingProfile: UserBillingProfile | null
  onAddCard: () => void
  onRemoveCard?: () => void
  disabled?: boolean
}) {
  const brand = capitalize(billingProfile?.cardBrand ?? '')
  const expiry = billingProfile
    ? formatCardExpiry(billingProfile.cardExpMonth, billingProfile.cardExpYear)
    : ''

  return (
    <Box>
      <Typography variant="subtitle1" fontWeight={600} gutterBottom>
        Payment Method
      </Typography>

      {!billingProfile?.cardLast4 && (
        <Stack spacing={2} alignItems="flex-start">
          <Typography variant="body2" color="text.secondary">
            No payment method on file.
          </Typography>
          <Button variant="contained" size="small" onClick={onAddCard} disabled={disabled}>
            Add Card
          </Button>
        </Stack>
      )}

      {billingProfile?.cardLast4 && (
        <Stack spacing={2}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <CreditCardIcon color="action" />
            <Box>
              <Typography variant="body1">
                {brand} **** {billingProfile.cardLast4}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Expires {expiry}
              </Typography>
            </Box>
          </Stack>
          <Stack direction="row" spacing={1}>
            <Button variant="outlined" size="small" onClick={onAddCard} disabled={disabled}>
              Update Card
            </Button>
            {onRemoveCard && (
              <Button
                variant="outlined"
                size="small"
                color="error"
                onClick={onRemoveCard}
                disabled={disabled}
              >
                Remove Card
              </Button>
            )}
          </Stack>
        </Stack>
      )}
    </Box>
  )
}
